export let loginvalue = "";
export function setloginvalue(value) {
    loginvalue = value;
};
export function getloginvalue() {
    return loginvalue;
};
export let email = "";
export function setEmail(value) {
    email = value;
};
export function getEmail() {
    return email;
};